// extracted by mini-css-extract-plugin
export default {"root":"cancelations_root__zfBUU","table":"cancelations_table__leHk-","chart":"cancelations_chart__kfe3K"};